<template>
  <div class="spinput">
    <b-form-group
      id="input-group-90000"
      class="form-control-alternative"
      label="Nom de l'article"
      label-for="input-5"
    >
      <b-form-input
        list="collection-id-sps"
        v-model="productName"
      ></b-form-input>

      <datalist id="collection-id-sps">
        <option v-for="sp in sps" :value="sp.value" :key="sp.value">
          {{ sp.text }}
        </option>
      </datalist>
    </b-form-group>
  </div>
</template>
<script>
import { get } from "@/mixins/api";
export default {
  data() {
    return {
      sps: [],
      allSps: [],
      productName: "",
      attributes: [],
      form: {},
      keyValuesAttr: {},
    };
  },
  watch: {
    productName: {
      handler: function (newVal) {
        this.$emit("attributes", []);
        this.$emit("newName", newVal);
        if (this.allSps.some((x) => x.name == newVal)) {
          const attr = this.allSps.find((x) => x.name == newVal).attributes;
          this.attributes = attr.length != 0 ? attr.split(";") : [];
          this.keyValuesAttr = this.attributes.reduce((acc, item) => {
            let arr = [];
            const key = item.substring(
              0,
              item.indexOf("~~") > 0 ? item.indexOf("~~") : item.length
            );
            if (item.indexOf("~~") > 0) {
              const withoutsep = item.substring(item.indexOf("~~") + 2);
              if (withoutsep.indexOf("~") <= 0) arr = [];
              else
                arr = withoutsep
                  .split("~")
                  .map((val) => ({ text: val, value: val }));
            }
            acc[key] = arr;
            return acc;
          }, {});
          this.attributes = this.attributes.map((attr) =>
            attr.substring(
              0,
              attr.indexOf("~~") > 0 ? attr.indexOf("~~") : attr.length
            )
          );
          this.$emit("form", {});
          this.attributes.forEach((element) => {
            this.form[element] = "";
          });
          this.$emit("attributes", this.attributes);
          this.$emit("form", this.form, this.keyValuesAttr);
        }
      },
      immediate: true,
    },
  },
  mounted() {
    get("stp").then((response) => {
      this.allSps = response.data.data;
      this.sps = response.data.data.map((x) => ({
        text: x.name,
        value: x.name,
      }));
    });
  },
};
</script>
<style lang="scss">
.spinput {
  #input-group-90000__BV_label_ {
    font-weight: bold;
  }
}
</style>